import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';
import { conditionLabel } from '../utils/usedGame';

var config = process.env;

class PurchaseProductComponent extends Component {

    constructor(){
        super();
        this.state = {
            items: [],
            itemsFiltered: [],
            itemsSelected: {},
            // ENI-202: desambiguador de código de barras. null = cerrado; array = candidatos que
            // comparten el código escaneado (típico: el usado lleva el mismo EAN que la copia nueva).
            barcodeMatches: null,
            barcodeScanned: '',
        }
        this.inputRef = React.createRef();
        // Contenedor del desambiguador: se le da foco al abrirlo para que Escape y los atajos
        // 1..9 lleguen (el onKeyDown vive ahí y sólo ve teclas que burbujean desde adentro).
        this.disambiguatorRef = React.createRef();
    }

    // ENI-202: el barCode se compara SIEMPRE como string normalizado. Con `==` la coerción hace
    // que '007' matchee 7 (dos EAN distintos), porque el alta del backoffice int-ifica el valor
    // contra una columna VARCHAR.
    normalizeBarcode = (value) => String(value ?? '').trim();

    drawUsedBadge = (product) => (
        Number(product.productType) === 3
            ? <span className="badge badge-warning ml-1">USADO{product.condition ? ` · ${conditionLabel(product.condition)}` : ''}</span>
            : null
    );
  

    componentWillMount() {
        this.loadProducts();
    }

    componentDidMount() {
        this.inputRef.current.focus();
    }
    
    loadProducts = () => {
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product/all', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.setState({items: data.data, itemsFiltered: data.data})
            }
        });
    }
    
    onChangeItem = (e) => {
        var itemsSelected = this.state.itemsSelected;
        if (e.target.checked) {
            var item = undefined;
            this.state.items.forEach(element => {
                var code = `${element.prefix}${element.code}`
                if (code == e.target.id) {
                    item = {
                        prefix: element.prefix,
                        code: element.code,
                        name: element.name,
                        quantity: 1,
                        price: element.price,
                        discount: element.discount,
                        productType: element.productType,
                        // ENI-202: sin esto la grilla del carrito no tiene de dónde sacar la condición.
                        condition: element.condition
                    }
                }
            })
            itemsSelected[e.target.id] = item;
        } else {
            delete itemsSelected[e.target.id]
        }
        //Update parent and state
        this.props.onChangeData(itemsSelected);
        this.setState({itemsSelected: itemsSelected});
    }

    loadItems = () => {
        var items = [];
        for(var i=0; i<this.state.itemsFiltered.length; i++) {
            var data = this.state.itemsFiltered[i];
            if (data.stock > 0) {
                items.push(
                    <div class="custom-control custom-checkbox mb-1" key={`${data.prefix}${data.code}`}>
                        <input onChange={(e) => this.onChangeItem(e)} type="checkbox" class="custom-control-input" id={`${data.prefix}${data.code}`} defaultChecked={`${data.prefix}${data.code}` in this.state.itemsSelected}/>
                        <label class="custom-control-label" for={`${data.prefix}${data.code}`}>{ data.name } ({data.stock}) {this.drawUsedBadge(data)}</label>
                    </div>
                );
            }
        }
        return (
            <div className="items">{ items }</div>
        );
    }

    onChangeInput = () => {
        var input = document.getElementById("input_search").value;
        var newList = [];
        for (var i=0; i<this.state.items.length; i++) {
            var name = this.state.items[i].name;
            var code = this.state.items[i].prefix + this.state.items[i].code;
            if (name.toLowerCase().includes(input.toLowerCase()) || code.toString().toLowerCase().includes(input.toLowerCase())) {
                newList.push( this.state.items[i] );
            }
        }
        this.setState({ itemsFiltered: newList });
    }

    drawModal = () => {
        return(
            <div className="modal fade" id={`modal-products`} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{textAlign: "center"}}>Agregar producto</h4>
                            <div class="form-group" style={{marginBottom: '0'}}>
                                <input type="text" class="form-control" id="input_search" placeholder="Buscar" onChange={() => this.onChangeInput()}/>
                            </div>
                        </div>
                        <div className="modal-body" style={{maxHeight: '70vh', overflowY: 'auto'}}>
                            { this.loadItems() }
                        </div>                        
                        <div className="modal-footer">
                            <button 
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm" 
                                data-dismiss="modal">
                                Cerrar
                            </button>                      
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    drawTable = () => {
        return (
            <table id="add-purchase-table" style={{width: '100%'}}>
                <thead>
                    <tr role="row">
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '10%'}}>Código</th>
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '30%'}}>Nombre</th>
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '10%'}}>Cantidad</th>
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '15%'}}>Precio</th>
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '15%'}}>Descuento</th>
                        <th className="table-purchase" rowspan="1" colspan="1" style={{width: '20%'}}>Precio final</th>
                    </tr>
                </thead>                
                { this.drawTableItems() }
            </table>
        );
    }

    drawTableItems = () => {
        var map = this.state.itemsSelected;
        var index = 0;
        var items = [];
        for (const [key, value] of Object.entries(map)) {
            items.push(this.drawRow(key, value, index));
            index++;
        }
        if (index == 0) {
            items.push(
                <tr><td colspan="6" style={{textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)'}}>No tienes elementos</td></tr>
            )
        }
        return (<tbody>{ items }</tbody>)
    }

    upQuantity = (code) => {
        var products = this.state.itemsSelected;
        var quantity = parseInt(products[code].quantity);
    
        var product;
        this.state.items.forEach(item => {
            var tempCode = item.prefix + item.code
            if (tempCode == code) {
                product = item;
            }
        });

        if (product != undefined && quantity < product.stock) {
            quantity += 1;
            products[code].quantity = quantity;
            this.props.onChangeData(products);
            this.setState({itemsSelected: products});
        }
    }

    downQuantity = (code) => {
        var products = this.state.itemsSelected;
        var quantity = parseInt(products[code].quantity);
        quantity -= 1;
        if (quantity > 0) {
            products[code].quantity = quantity;
            this.props.onChangeData(products);
            this.setState({itemsSelected: products});
        }
    }

    drawRow = (code, item, index) => {
        return(
            <tr role="row" class="odd table-purchase-item" key={ code } style={{background: (index % 2 == 0) ? '#ffffff;' : '#fcfcfc' }}>
                <td class="table-purchase-item">{code}</td>
                <td class="table-purchase-item">{item.name} {this.drawUsedBadge(item)}</td>
                <td class="table-purchase-item">
                    <div class="row" style={{marginLeft: '0', marginRight: '0'}}>
                        <div class="col" style={{padding: '0', cursor: 'pointer'}} onClick={() => this.downQuantity(code)}>
                            <span class="input-group-text" style={{padding: '4px'}}>-</span>
                        </div>
                        <div class="col" style={{marginTop: '2px'}}>
                            {item.quantity}
                        </div>
                        <div class="col" style={{padding: '0', cursor: 'pointer'}} onClick={() => this.upQuantity(code)}>
                            <span class="input-group-text" style={{padding: '4px'}}>+</span>
                        </div>
                    </div>
                </td>
                <td class="table-purchase-item">{convertToMoney(item.price)}</td>
                <td class="table-purchase-item">{item.discount}</td>
                <td class="table-purchase-item">{convertToMoney(item.quantity * item.price * (1 - (item.discount / 100)))}</td>
            </tr>
        );
    }

    // Función de debounce
    debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // ENI-202: alta de un producto al carrito (o +1 si ya estaba). Extraído para que lo usen
    // tanto el escaneo con match único como la elección del desambiguador.
    addProductToCart = (element) => {
        const key = `${element.prefix}${element.code}`;
        const itemsSelected = this.state.itemsSelected;
        const existing = itemsSelected[key];
        // El +1 respeta el stock, igual que el botón "+" de la grilla (upQuantity). Sin el tope,
        // escanear N veces el mismo producto vendía más de lo que hay — feo en general y peor
        // con un usado, que tiene stock 1.
        if (existing != null && !(existing.quantity < Number(element.stock))) {
            return;
        }
        itemsSelected[key] = existing != null
            ? { ...existing, quantity: existing.quantity + 1 }
            : {
                prefix: element.prefix,
                code: element.code,
                name: element.name,
                quantity: 1,
                price: element.price,
                discount: element.discount,
                productType: element.productType,
                condition: element.condition,
            };
        this.props.onChangeData(itemsSelected);
        this.setState({ itemsSelected });
    }

    // El id "barCode" está duplicado en varios componentes hermanos, así que getElementById
    // puede agarrar el input de otro. Se usa el ref propio y se devuelve el foco: sin eso el
    // scan siguiente se pierde.
    // `refocus` es la parte delicada: al ABRIR el desambiguador hay que vaciar el input pero NO
    // devolverle el foco, porque si no la pistola sigue alimentando un campo tapado por el
    // backdrop y esos escaneos se pierden sin dejar rastro.
    clearBarcodeInput = (refocus = true) => {
        const input = this.inputRef.current;
        if (input) {
            input.value = '';
            if (refocus) {
                input.focus();
            }
        }
    }

    pickBarcodeMatch = (element) => {
        this.addProductToCart(element);
        this.setState({ barcodeMatches: null, barcodeScanned: '' }, () => this.clearBarcodeInput());
    }

    closeBarcodeDisambiguator = () => {
        this.setState({ barcodeMatches: null, barcodeScanned: '' }, () => this.clearBarcodeInput());
    }

    // Función para manejar el cambio en el input con debounce
    handleBarcodeChange = this.debounce((event) => {
        // ENI-202: antes esto recorría con forEach SIN cortar y daba de alta DENTRO del loop, así
        // que si varios productos compartían el código se agregaban TODOS en silencio — el caso
        // típico es el usado, que lleva el mismo EAN impreso que la copia nueva.
        const scanned = this.normalizeBarcode(event.target.value);
        if (scanned === '' || scanned === '0') {
            return;
        }
        // Con el desambiguador abierto se ignora el scan nuevo para no pisar la elección pendiente.
        if (this.state.barcodeMatches != null) {
            return;
        }
        const matches = this.state.items.filter((element) => {
            const barCode = this.normalizeBarcode(element.barCode);
            // Sólo vendibles: el selector manual ya esconde el stock 0 (loadItems) y antes el
            // escaneo lo agregaba igual. Además, un usado ya vendido (stock 0) conserva su fila
            // con el mismo EAN, así que sin este filtro forzaría el desambiguador para siempre.
            return barCode !== '' && barCode !== '0' && barCode === scanned && Number(element.stock) > 0;
        });
        if (matches.length === 0) {
            // OJO: NO limpiar el input acá. La pistola dispara un onChange por carácter, así que
            // mientras escribe hay prefijos que todavía no matchean; limpiar rompería el escaneo.
            return;
        }
        if (matches.length === 1) {
            this.addProductToCart(matches[0]);
            this.clearBarcodeInput();
            return;
        }
        // Varios productos con el mismo código: que el operador elija, en vez de agregarlos a
        // todos o adivinar. Se ordena nuevo primero para que el orden no dependa del catálogo.
        const sorted = [...matches].sort((a, b) => (Number(a.productType) === 3) - (Number(b.productType) === 3));
        this.setState({ barcodeMatches: sorted, barcodeScanned: scanned }, () => {
            // Vaciar el input SIN devolverle el foco, y mover el foco al modal: así Escape y los
            // atajos 1..9 funcionan, y la pistola no puede seguir cargando un campo tapado.
            this.clearBarcodeInput(false);
            if (this.disambiguatorRef.current) {
                this.disambiguatorRef.current.focus();
            }
        });
    }, 150);

    onDisambiguatorKeyDown = (event) => {
        const matches = this.state.barcodeMatches || [];
        if (event.key === 'Escape') {
            this.closeBarcodeDisambiguator();
            return;
        }
        // Atajos 1..9: es un flujo de caja con la pistola en la mano, obligar al mouse lo hace lento.
        const index = Number(event.key) - 1;
        if (Number.isInteger(index) && index >= 0 && matches[index]) {
            this.pickBarcodeMatch(matches[index]);
        }
    }

    drawBarcodeDisambiguator = () => {
        const matches = this.state.barcodeMatches;
        if (matches == null) {
            return null;
        }
        return (
            <React.Fragment>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog" tabIndex={-1} ref={this.disambiguatorRef} onKeyDown={this.onDisambiguatorKeyDown}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div>
                                    <h4 className="modal-title mb-1">¿Cuál de estos productos?</h4>
                                    <small className="text-muted">
                                        El código {this.state.barcodeScanned} corresponde a {matches.length} productos. Elegí uno.
                                    </small>
                                </div>
                                <button type="button" className="close" onClick={this.closeBarcodeDisambiguator}><span>&times;</span></button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                <div className="list-group">
                                    {matches.map((element, index) => (
                                        <button
                                            type="button"
                                            key={`${element.prefix}${element.code}`}
                                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                            autoFocus={index === 0}
                                            onClick={() => this.pickBarcodeMatch(element)}
                                        >
                                            <span>
                                                {index + 1}. {element.name} {this.drawUsedBadge(element)}
                                                <small className="text-muted d-block">{element.prefix}{element.code} · Stock {element.stock}</small>
                                            </span>
                                            <strong>$ {convertToMoney(element.price)}</strong>
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" onClick={this.closeBarcodeDisambiguator}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" onClick={this.closeBarcodeDisambiguator}></div>
            </React.Fragment>
        );
    }

    render() {
        return (
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    {this.props.isPurchaseChange ? 
                        <div style={{fontSize: '24px', textAlign: 'center', marginTop:'10px'}}>
                            <label>Seleccione los juegos nuevos</label>
                        </div> : "" 
                    }
                    <div className="card-header border-bottom ">
                        <div className="row">
                            <span className="col-lg-4">Productos</span> 
                            <input autoComplete="off" className="col-lg-4 form-control" type="text" id="barCode" placeholder="Código de barras" ref={this.inputRef} onChange={(e) => this.handleBarcodeChange(e)}/>
                            <button data-toggle="modal" data-target={`#modal-products`} type="button" className="btn btn-outline-primary col-lg-4" style ={{float: 'right'}}>Agregar</button>
                         </div>
                       </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item p-3">
                            { this.drawTable() }
                        </li>
                    </ul>
                </div>
                { this.drawModal() }
                { this.drawBarcodeDisambiguator() }
            </div>
        );
    }
}

export default PurchaseProductComponent;